<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div class="mb-3" :class="{'section-loading': infoLoading}" style="overflow: hidden;max-height: 140px;">
        <div class="float-left w-75  pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">{{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}  
            <!--<i v-if="categoryInfo.upload_file =''" class="icon-attach text-orange ml-2"></i><span style="font-size: medium;color: black;">{{ categoryInfo.upload_file | removeExten }}</span>-->
            <a class="text-orange" style="text-decoration:none;">
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>點我
            </a>
          </h4>
          <div class="mb-line" style=""><span class="font-weight-bold mr-2">{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span></div>
          <div class="mb-line w-75"><span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span></div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line"><span class="font-weight-bold mr-2">維護單位</span> <span>{{ categoryInfo.dev_name }}</span></div>
          <div class=""><span class="font-weight-bold mr-2">聯絡電話</span> <span>{{ categoryInfo.contact }}</span></div>
          <div class="mb-line"><span class="font-weight-bold mr-2">聯絡分機</span> <span>{{ categoryInfo.contact_tel }}</span></div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
            type="button"
            style="height:43px;"
            @click="backToIndex"
            class="position-absolute btn btn-default m-0"
            v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
          ></button> 
          </div>  
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <health-ceremony-data-table
        :height="data_table_height"
        @update="updateSelection"
        @health-ceremony-modal="healthCeremonyModal"
        @jump-to-customer="jumpToCustomer"
        @scheduled-access="ScheduledAccess"
        :table-data="tableData"/>
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12">
        </div>
        <div class="col-9 col-sm-8 col-md-8">
          <div class="list inline">
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">要</span>
              <small class="text">壽險要保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">被</span>
              <small class="text">壽險主被保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">意</span>
              <small class="text">意外被保險人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">團</span>
              <small class="text">團險被保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">借</span>
              <small class="text">房貸借款人</small>
            </div>
          </div>
        </div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button class="btn btn-primary"
          @click="panelOpen('groupModalOpen')"
          :disabled="!selection.length">
            加入群組
          </button>
          <button class="btn btn-primary mr-0"
          @click="panelOpen('printModalOpen')"
          :disabled="!selection.length">
            列印名條
          </button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal
    :open="printModalOpen"
    :custs="selection"
    @close="panelClose('printModalOpen')"/>

    <!-- 加入群組 -->
    <group-modal
    :open="groupModalOpen"
    :custs="selection"
    @submit="submitGroup"
    @close="panelClose('groupModalOpen')"/>

    <health-ceremony-modal
        :open="healthCeremonyModalOpen"
        :title="health_title"
        :present ="present"
        @close="panelClose('healthCeremonyModalOpen')"
    />

    <satisfaction-modal 
        :open="satisfactionModalOpen"
        @report="report"
        @close="panelClose('satisfactionModalOpen')"
    />

    <scheduled-access
    :open="ScheduledAccessModalOpen"
    :record="currentRecord"
    :cat-info="categoryInfo"
    @close="panelClose('ScheduledAccessModalOpen')"
    @submit="submitScheduledAccess"
    />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import PrintModal from '@/desktop/components/PrintModal'
import GroupModal from '@/desktop/components/GroupModal'
import HealthCeremonyDataTable from '../DataTable/HealthCeremonyDataTable'
import HealthCeremonyModal from '../HealthCeremonyModal'
import SatisfactionModal from '../SatisfactionModal'
import { getHealthCeremony ,getCategoryDetail, isSatisfactionSurveyFinish, queryBookedVisitEvent,downloadFile_m0 } from '@/service'
import { saveAs } from 'file-saver';
import ScheduledAccess from '../ScheduledAccess'

const health_ceremony = {
  title: 'VIP專區-健康禮(符合資格)',
  date: '108/01/01 ~',
  desc: '國泰一家人VIP家庭服務介紹與內容',
  department: '客戶關係發展科',
  phone: '(02)27551399',
  ext: '7136',
}

export default {
  name: 'HealthCeremony',
  mixins: [commonMixin],
  components: {
    HealthCeremonyDataTable, 
    HealthCeremonyModal, 
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess,  
  },
  props: {
    status: String
  },
  computed: {
    
  },
  data () {  //data block layout
    return {
      currentPage: 0,
      isLoading_btn: true,
      isLoading: false,
      infoLoading: false,
      isBtnEnble:true,
      categoryInfo: {},
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      visitList: [],
      healthCeremonyModalOpen: false,
      satisfactionModalOpen: false,
      comment: '',
      present: '',
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      currentRecord: {},
      edit_access_index: 0,
      edit_access_name: '',
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      health_title: '健康禮品項',
      info: {}
    }  
  },
  methods: {
    ...mapActions([
      'setPageLock', 'updateCustID'
    ]),
    updateSelection (val) {
      this.selection = val
    },
    commentModal(comment) {
        this.comment = comment
        this.panelOpen('commentModalOpen');
    },
    satisfactionModal() {
        this.panelOpen('satisfactionModalOpen');
    },
    report() {
        this.$toast.info({title:'滿意度調查 已回報'});
        this.isBtnEnble = false
        this.panelClose('satisfactionModalOpen')
    },
    jumpToCustomer(index) {  // 導頁到客戶資料
      this.updateCustID(index)
      localStorage.CustID = index
      this.$router.push({path: `/detail/CustID/tab/1`})
    },
    backToIndex() {  // 回上一頁
      this.$emit('change-status','STATUS_SERVICE_RIGHT_LIST');
    },
    submitGroup (group) {  // 加入群組導頁至 群組列表
      this.panelClose('groupModalOpen')
      this.$router.push({path:`/group/1`, query:{grp_id: group.grp_id, grp_name: group.grp_name}})
    },
    formatRelation (val) {  //  轉換親屬關係
      const filterData = [
        {name: '配偶', code: '0'},
        {name: '父母', code: '1'},
        {name: '子女', code: '2'},
        {name: 'VIP本人', code: '9'},
      ]
      let reData = ''
      filterData.forEach(item => {
        if(val == item.code) {
          reData = item.name
        }
      })
      return reData
    },
    idmarkFormat (obj) {  //  轉換 idmark code
      if(typeof obj == 'object') {
        let data = []
        for (let index in obj) {
          if(obj[index] == '1'){
            data.push(index.substr(-1))
          }
        }
        return data
      }else{
        return ["N","N","N","N","N","N"]
      }
    },
    initHealth () {  // 資料初始化
      this.checkIsSatisfactionSurveyFinish()
      this.isLoading = true
          getHealthCeremony(this.$store.state.userInfo.id).then(result => {
            this.isLoading = false
            if(result.header && result.header.status === '200' && result.body.lists) {
              let connect='';
              let CsidData='';
              result.body.lists.map(item => {
                  connect = connect+','+item.id;
              })
              if(connect.length>0){
                CsidData = connect.substr(1);
              }else{
                CsidData=''
              }
              queryBookedVisitEvent(this.$store.state.userInfo.id,CsidData).then(visitData => {
                  this.isLoading = false
                  if(visitData.header && visitData.header.status === '200') {
                    this.visitList = visitData.body.detail;
                    this.tableData = result.body.lists.map(item => {
                    let visit = {visit: {}}
                    this.visitList.forEach(vItem => {
                      if(vItem.csidno == item.id) {
                        visit.visit = vItem
                      }
                    })
                    return {
                      name: item.name || '', //客戶姓名
                      id: item.id || '', //客戶ID
                      sex: item.id[1] || '', //性別
                      mobile: item.mobile || '', //客戶手機
                      member_name: item.member_name || '', //家庭成員姓名
                      relationship: this.formatRelation(item.relationship) || '', //親屬關係
                      qualification: item.qualification, //健康禮資格
                      present: item.present, //健康禮品項
                      apply_time: item.apply_time, //申請日期
                      is_exist: item.is_exist || false, //判斷是否有客戶資料
                      recordInfo: {},
                      ...visit, // 寫入排訪資料
                    }
                    })
                  }
                })
              this.registerHanlink()  // for hard word
            }
          })
      this.getTitleInfo()
    },
    getTitleInfo () {  // 取得專區資訊
      this.infoLoading = true
      getCategoryDetail(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        this.infoLoading = false
        if(result.header && result.header.status == '200'){
          this.categoryInfo = result.body[0]
        }
      })
    },
    checkIsSatisfactionSurveyFinish () {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true
      isSatisfactionSurveyFinish(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        if(result.header && result.header.status == '200') {
          this.isBtnEnble = result.body.isfinish == '0' 
        } else {
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢滿意度調查失敗,請重新操作'})
          }
        }
        this.isLoading_btn = false
      })
    },   
    alreadyDone() {
      this.$toast.info({title: '您已回報過滿意度調查,無法重複操作'})
    },        
    ScheduledAccess(record) {
      this.currentRecord = record
      this.panelOpen('ScheduledAccessModalOpen')
    },
    submitScheduledAccess() {
      this.panelClose('ScheduledAccessModalOpen')
      // 資料初始化
      this.initHealth()
    },
    healthCeremonyModal(present) {
        this.present = present
        this.panelOpen('healthCeremonyModalOpen');
    },
    download () {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(this.$store.state.userInfo.id, this.categoryInfo.ser_no, this.categoryInfo.upload_file).then(
          result => {
            if (result.type == "application/json") {
              //  json 為檔案下載失敗
              //  把回傳的 blob 轉為 文字檔後再用 json parse
              let reader = new FileReader();
              reader.onload = function() {
                let unicodeJsonA = JSON.parse(reader.result);
                if (unicodeJsonA.header.message) {
                  vm.setToastMsg(unicodeJsonA.header.message);
                } else {
                  vm.setToastMsg("伺服器連線異常");
                }
              };
              reader.readAsText(result);
            } else {
              //  成功取得檔案  進行下載
              saveAs(result, this.categoryInfo.upload_file);
            }
          }
        );
      }
    }
  },
  mounted () {
    // 資料初始化
    this.initHealth()
    
    this.data_table_height = parseInt($(window).height()) - $('tbody').offset().top - 80
    let self = this;
    $(window).bind('orientationchange', function(event) {
      self.data_table_height = parseInt($(window).height()) - $('tbody').offset().top - 80;
    });
    $(".tab-content").css("padding-bottom","74px");
  }
}
</script>
